import { Carousel } from '@geberit/gdds';

// styles
import styles from './image-gallery.module.scss';

// types
import type { WrapperProps } from '../types';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { classNameBuilder } from 'utils/classNameBuilder';

export function Wrapper({ children, imageGallery }: Readonly<WrapperProps>) {
  const isMobile = useIsMobile();


  if (imageGallery?.length > 2 || (isMobile && imageGallery?.length > 1)) {
    return (
      <Carousel
        responsiveLayout={{
          small: { slides: 1.3, slidesToMove: 1 },
          medium: { slides: 2, slidesToMove: 1 },
          large: { slides: 2, slidesToMove: 1 },
        }}
        hideButtons={isMobile}
        supportMouse
      >
        {children}
      </Carousel>
    );
  }

  return (
    <div className={classNameBuilder(styles.withoutCarousel)}>{children}</div>
  );
}
